<template>
	<div>
		<right-panel :datas="memberInfo" @onClose="onCloseForm()" @onSubmit="onChangeMember(memberInfo.id, 'setMemberForm')" ref="rightPanelSet">
			<div slot="header">
				<translate>Base Info</translate>
			</div>
			<div slot="content" v-if="memberInfo" class="wrapper-padding">
				<div class="detail-wrapper">
					<el-form :model="setMember" :rules="rules" ref="setMemberForm" label-width="130px" class="demo-ruleForm team-MemberForm">
						<el-form-item :label="attrText.displayNickname" :class="[1, 3].includes($store.getters.account.is_admin) ? '' : 'fixed-text'">
							<el-input v-if="[1, 3].includes($store.getters.account.is_admin)" type="text" v-model="setMember.name" auto-complete="off"></el-input>
							<span v-else>{{ memberInfo.name }}</span>
						</el-form-item>
						<el-form-item :label="attrText.account" class="fixed-text">
							{{ memberInfo.account }}
						</el-form-item>
						<el-form-item :label="attrText.pwd" prop="password">
							<!-- 使用隐藏的假输入框欺骗浏览器自动填充 -->
							<input type="text" style="display: none" />
							<input type="password" style="display: none" />
							<el-input type="password" v-model="setMember.password" :placeholder="attrText.empty" auto-complete="new-password" name="new-password"></el-input>
							<translate v-show="show_password_warning && company_password_strength == 1">The administrator has enabled the password strength setting. The password must be at least 6 characters long and must contain two of uppercase letters, lowercase letters, and special characters.</translate>
							<translate v-show="show_password_warning && company_password_strength == 2">The administrator has enabled the password strength setting. The password must be at least 8 characters long and must contain uppercase letters, lowercase letters, and special characters.</translate>
						</el-form-item>
						<el-form-item :label="attrText.repwd" prop="checkPass">
							<el-input type="password" v-model="setMember.checkPass" auto-complete="new-password" name="new-password-check"></el-input>
						</el-form-item>
						<el-form-item :label="attrText.role" class="select-role">
							<el-select :disabled="memberInfo.id === $store.getters.account.id || memberInfo.account === $store.getters.team.setting.email" v-model="setMember.is_admin" :placeholder="attrText.selectRole">
								<el-option :label="attrText.admin" value="1"></el-option>
								<el-option :label="attrText.optAdmin" value="3"></el-option>
								<el-option :label="attrText.auditAdmin" value="2"></el-option>
								<el-option :label="attrText.safeAdmin" value="4"></el-option>
								<el-option :label="attrText.ordinary" value="0"></el-option>
							</el-select>
						</el-form-item>
					</el-form>
				</div>
			</div>
			<div slot="footer" class="detail-btn">
				<el-button type="primary" @click="onChangeMember(memberInfo.id, 'setMemberForm')">
					<translate>Save</translate>
				</el-button>
				<el-button @click="$refs.rightPanelSet.onClose()">
					<translate>Cancel</translate>
				</el-button>
			</div>
		</right-panel>
	</div>
</template>

<script>
import STORE_CONST from '../../../store/consts'
import RightPanel from '../../common/right-panel'
import { PasswordStrengthRegExp, PasswordStrengthRegExpCallback } from '../../../config'
export default {
	name: 'TeamMemberSetting',
	props: {
		items: {
			required: true,
		},
	},
	data() {
		let validatePass = (rule, value, callback) => {
			let level = this.company_password_strength
			var uppercasePattern = PasswordStrengthRegExp.uppercasePattern
			var lowercasePattern = PasswordStrengthRegExp.lowercasePattern
			var sysbolPattern = PasswordStrengthRegExp.sysbolPattern
			var uppercaseRes = uppercasePattern.test(value)
			var lowercaseRes = lowercasePattern.test(value)
			var sysbolRes = sysbolPattern.test(value)
			if (value.length) {
				if (level === 1) {
					if (value.length >= 6 && ((lowercaseRes && uppercaseRes) || (lowercaseRes && sysbolRes) || (uppercaseRes && sysbolRes))) {
						callback()
					} else {
						this.show_password_warning = false
						callback(new Error(this.$gettext(PasswordStrengthRegExpCallback.level1_msg)))
					}
				} else if (level === 2) {
					if (value.length >= 8 && lowercaseRes && uppercaseRes && sysbolRes) {
						callback()
					} else {
						this.show_password_warning = false
						callback(new Error(this.$gettext(PasswordStrengthRegExpCallback.level2_msg)))
					}
				} else {
					// level为0
					callback()
				}
			} else {
				callback()
				setTimeout(() => {
					this.show_password_warning = true
				}, 300)
			}
			// 密码变化时，触发重复密码字段的校验
			if (this.$refs.setMemberForm) {
				this.$refs.setMemberForm.validateField('checkPass')
			}
		}
		let validateCheckPass = (rule, value, callback) => {
			// 如果输入了密码但没有输入重复密码，不允许保存
			if (this.setMember.password && !value) {
				callback(new Error(this.$gettext('Please confirm your password')))
			} else if (value && value !== this.setMember.password) {
				// 如果输入了重复密码但与密码不一致
				callback(new Error(this.$gettext('Two passwords are not consistent!')))
			} else {
				callback()
			}
		}
		return {
			memberInfo: null,
			company_password_strength: this.$store.getters.team.setting.password_strength || 0,
			show_password_warning: this.$store.getters.team.setting.password_strength !== '0',
			setMember: {
				name: '',
				password: '',
				checkPass: '',
				is_admin: '',
			},
			rules: {
				password: [{ validator: validatePass, trigger: 'blur,change' }],
				checkPass: [{ validator: validateCheckPass, trigger: 'change' }],
			},
		}
	},
	computed: {
		attrText() {
			return this.initAttrText()
		},
	},
	created() {
		setTimeout(() => {
			console.log('this.memberInfo', this.items)
			this.setMember.is_admin = this.items.is_admin.toString()
			this.setMember.name = this.memberInfo.name
		}, 300)
	},
	methods: {
		initAttrText() {
			return {
				optAdmin: this.$gettext('Opt Admin'),
				auditAdmin: this.$gettext('Audit Admin'),
				safeAdmin: this.$gettext('Safe Admin'),
				admin: this.$gettext('Administrator'),
				ordinary: this.$gettext('Ordinary User'),
				name: this.$gettext('Full Name'),
				displayNickname: this.$gettext('Display Nickname'),
				email: this.$gettext('Email'),
				pwd: this.$gettext('Password'),
				repwd: this.$gettext('Repeat Password'),
				role: this.$gettext('Role'),
				selectRole: this.$gettext('Select Role'),
				account: this.$gettext('Account'),
			}
		},
		// 提交修改成员信息
		onChangeMember(id, formName) {
			this.$refs[formName].validate((valid) => {
				if (valid) {
					let params = {
						data: {
							id: id,
							data: {
								name: this.setMember.name,
								is_admin: this.setMember.is_admin,
							},
						},
					}
					if (this.setMember.password !== '') {
						params.data.data.pwd = this.setMember.password
					}
					this.$store.dispatch(STORE_CONST.TEAM.EDIT_MEMBER, params).then(
						() => {
							// 修改的是当前登录用户时，重新拉取账号信息，同步更新 header 中展示的昵称
							if (id === this.$store.getters.account.id) {
								this.$store.dispatch(STORE_CONST.ACCOUNT.CURRENT)
							}
							this.$refs.rightPanelSet.onClose()
							this.$emit('callback')
							this.$notify({
								type: 'success',
								message: this.$gettext('update account success'),
							})
						},
						() => {
							this.$refs.rightPanelSet.onClose()
						},
					)
				} else {
					return false
				}
			})
		},
		onCloseForm() {
			this.memberInfo = null
			this.$emit('onClosePanel')
		},
	},
	watch: {
		//      'setMember': {
		//        handler: function (newVal, oldVal) {
		//          this.$refs['setMemberForm'].validate((valid) => {
		//            this.setMember.isDisabled = !valid
		//          })
		//          if (this.setMember.is_admin !== '') {
		//            this.setMember.isDisabled = false
		//          }
		//        },
		//        deep: true
		//      },
		items: {
			handler: function (newVal) {
				if (this.memberInfo) {
					this.memberInfo = null
					setTimeout(() => {
						this.memberInfo = this.items
					}, 300)
				} else {
					this.memberInfo = this.items
				}
			},
			deep: true,
		},
	},
	components: {
		RightPanel,
	},
}
</script>

<style lang="scss" rel="stylesheet/scss">
.team-MemberForm {
	.el-form-item__content {
		line-height: 20px;
	}
	.el-form-item {
		margin-bottom: 30px;
		&.is-error {
		}
	}
}
</style>



// WEBPACK FOOTER //
// team-member-setting.vue?1102dd2a